import { createRoutesFromElements, Navigate, Route } from 'react-router-dom'

import App from '../components/App'
import CalendarWidget from '../components/Calendar/CalendarWidget/CalendarWidget.jsx'
import ConnectionTesting from '../components/ConnectionTesting/ConnectionTesting'
import HolidayTips from '../components/HolidayTips/HolidayTips'
import { NotFound } from '../components/NotFound'
import { authRoutesConfig } from './routes/auth.routes'
import { dashboardRoutesConfig, reservationsRoutesConfig } from './routes/dashboard.routes'
import { marketShopRoutesConfig } from './routes/market-shop.routes'
import { packageRoomRoutesConfig } from './routes/package-room.routes'
import { valetParkingRoutesConfig } from './routes/valet-parking.routes'
import { visitorParkingRoutesConfig } from './routes/visitor-parking.routes'

export const routeConfig = createRoutesFromElements(
  <Route path="/" element={<App />}>
    {/* AUTH */}
    <Route index element={<Navigate replace to="login" />} />
    {authRoutesConfig()}

    {/* EXTERNAL FLOWS */}
    {packageRoomRoutesConfig()}
    {visitorParkingRoutesConfig()}
    {valetParkingRoutesConfig()}
    {marketShopRoutesConfig()}
    <Route path="calendar-widget" element={<CalendarWidget />} />

    {/* DASHBOARD */}
    {dashboardRoutesConfig()}
    {reservationsRoutesConfig()}

    {/* PUBLIC */}
    <Route path="optimatips" element={<HolidayTips />} />
    <Route path="connection-tool" element={<ConnectionTesting />} />
    <Route path="*" element={<NotFound />} />
  </Route>,
)
